import { History } from 'history'

export interface DivergenceDemandsState {
    user: User
    divergence: DivergenceData[]
    divergenceFilters: DivergenceFilters
    divergenceFilterOptions?: DivergenceFilterOptions
    activeDivergenceId?: string
    divergenceActiveAddress?: string
    divergenceActiveProduct?: string
    divergenceActiveProductDesc?: string
    activeDivergenceItemId?: string
    productResolutionData?: ProductResolutionData
    pagination?: PaginationInfo
}

export interface PaginationInfo {
    currentPage: number
    perPage: number
    totalItems: number
    totalPages: number
}

export interface ProductResolutionData {
    createdAt: string
    divergentQuantity: number
    expirationDate: string
    id: number
    idStatus: number
    idStockDivergenceDemand: number
    idSupervisor: number | null
    inputQuantity: number
    stockQuantity: number
    updatedAt: string
}

export interface User {
    user: string | undefined
    badge: string | undefined
    userId: number | undefined
}

export interface RootState {
    divergenceDemands: DivergenceDemandsState
}

export enum GenericApiErrors {
    Failed,
}

export interface SetProperty {
    property: keyof DivergenceDemandsState
    value: DivergenceDemandsState[keyof DivergenceDemandsState]
}

export interface ValidatedBadge {
    user: string
}

export interface ValidatedManagerBadge {
    user: string
    userId: number
    hasUser?: string
}

export interface ValidateBadgePayload {
    badge: string
    history?: History
    createList?: boolean
    setError: (error: string) => void,
    onSuccess: (arg?: any) => any
}

export interface ValidateManagerBadgePayload {
    badge: string
    divergenceId: string
    setError: (error: string) => void,
    onSuccess: (arg?: any) => any
    onUserInUse?: (userName: string) => void
    setUser?: boolean
}

export interface DivergenceData {
    id?: string
    codProd?: string
    descProd?: string
    location?: string
    type?: string
    status?: string
    date?: string
    quantity?: number
    cost?: number
    floor?: string
}

export interface DivergenceFilters {
    status?: number[]
    floor?: 0 | 1 | null
    initial_date?: string
    final_date?: string
    cod_prod?: string
    level?: 1 | 2 | 3 | null
    street?: string
    shed?: string
    type?: 0 | 1 | null
    page?: number
    per_page?: number
}

export interface FilterOption<T = any> {
    value: T
    label: string
}

export interface DivergenceFilterOptions {
    status: FilterOption<number>[]
    floor: FilterOption<0 | 1 | null>[]
    level: FilterOption<1 | 2 | 3 | null>[]
    type: FilterOption<0 | 1 | null>[]
}

export interface DivergenceFilterOptionsResponse {
    status: string
    data: DivergenceFilterOptions
}

export interface GetDivergencePayload {
    filters?: DivergenceFilters
}

export interface DivergenceApiResponse {
    status: string
    data: DivergenceData[]
    pagination: PaginationInfo
}

export interface SetDivergence {
    divergence: DivergenceData[]
}

export interface SetDivergenceFilters {
    filters: DivergenceFilters
}

export interface SetActiveDivergence {
    divergenceId: string,
    location: string,
    product: string,
    productDesc?: string,
}

export interface SetDivergenceFilterOptions {
    filterOptions: DivergenceFilterOptions
}

export interface StartDivergenceResolutionPayload {
    divergenceId: string,
    prodBarcode: string,
    userBadge: string,
    setError: (error: string) => void,
    onSuccess: (arg?: any) => any
}

export interface StartDivergenceResolutionResponse {
  id: string,
  status: string,
  expiration_date: string,
  divergent_quantity: number
}

export interface ProductNotFoundPayload {
    divergenceId: string,
    onSuccess: (arg?: any) => any
    onError: (error: string) => void
}

export interface ProductNotFoundResponse {
  success: boolean
}

export interface StartItemResolutionPayload {
    divergenceId: string,
    divergenceItemId: string,
    userBadge: string,
    locationAddress: string,
    countedQuantity: number
    history?: History
    onSuccess: (arg?: any) => any
    onError: (error: string) => void
}

export interface StartItemResolutionResponse {
  id: string,
  status: string,
  expirationDate: string,
  locationAddress: string
}

export interface ValidateProductPayload {
    divergenceId: string,
    prodBarcode: string
    onSuccess: (arg?: any) => any
    onError: (error: string) => void
}

export interface ValidateProductResponse {
  id: string,
  status: string,
  expiration_date: string,
  divergent_quantity: number
}
export interface ValidateProductApiPayload {
  divergenceId: string
  prodBarcode: string
  userBadge: string
}

export interface ProductNotFoundApiPayload {
  divergenceId: string
  userBadge: string
}

export interface StartItemResolutionApiPayload {
  divergenceId: string
  divergenceItemId: string
  userBadge: string
  locationAddress: string
  countedQuantity: number
}

export interface ValidateManagerBadgeApiPayload extends ValidateManagerBadgePayload {
  setUser?: boolean
}
